import React from 'react';
import isFunction from 'lodash/isFunction';

import './header-component.scss';

export default function HeaderComponent({ headerActions }) {
  const renderAction = (action) => {
    const { component: Component, componentProps, children } = action;
    return <Component {...componentProps}>{isFunction(children) ? children() : children}</Component>;
  };

  const renderActions = (actions) => {
    return actions.map((action) => {
      return (
        <div key={action.actionId} className="action-wrapper">
          {renderAction(action)}
        </div>
      );
    });
  };

  return (
    <div className="header-component">
      <div className="actions-wrapper left">{renderActions(headerActions.leftActions)}</div>
      <div className="actions-wrapper middle">{renderActions(headerActions.middleActions)}</div>
      <div className="actions-wrapper right">{renderActions(headerActions.rightActions)}</div>
    </div>
  );
}
